__turbopack_context__.v({
  "className": "roboto_1bdd1935-module__YWGVAq__className",
  "variable": "roboto_1bdd1935-module__YWGVAq__variable",
});
